// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBQ7HyBAhavn1dS0oZG6_eKRgA9WdrVEJg",
  authDomain: "info-curiose.firebaseapp.com",
  projectId: "info-curiose",
  storageBucket: "info-curiose.firebasestorage.app",
  messagingSenderId: "1087095523706",
  appId: "1:1087095523706:web:31d034421c81e9785caec3",
  measurementId: "G-9F3W0CZEKC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
const database = getDatabase(app);
const auth = getAuth(app); //crea istanza di auth

export {app, database, auth}
export const storage = getStorage(app);  // AGGIUNTO

